import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/service-request-schema'
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'

const { serviceRequestSchema: schema } = schemaSettings
const service = apiClient.service('service-requests')

export default ({ name, app }) => {
  app.on('initialized', () => {
    const addUniqueServiceRequest = app.getSequence('serviceRequests.addUniqueServiceRequest')

    apiClient.on('login', () => {
      // Computed state is not available until next tick.
      setTimeout(addUniqueServiceRequest, 0)
    })

    addUniqueServiceRequest()

    service.on('created', (serviceRequest) => addUniqueServiceRequest({ serviceRequest }))
    service.on('patched', (serviceRequest) => addUniqueServiceRequest({ serviceRequest }))
  })

  return {
    state: {
      ...createCrudState({ entityType: 'serviceRequests', storePrefix: name }),
      pendingRequests: [],
    },
    sequences,
    providers: createProviders({ name, service, schema }),
    catch: [
      redirectUnauthorized(),
      [
        Error,
        showFeedbackFromError({ title: 'We encountered an error' }),
        ({ props: { error, errorPath = name }, store }) => {
          store.set(state`errors.${errorPath}`, error)
        },
      ],
    ],
  }
}
